import Vue from "vue";
import store from "./store";
import i18n from "./lang";
import router from "./router";
import App from "./App.vue";

import "./main";

new Vue({
  router,
  store,
  i18n,
  render: (h) =>
    h(App, {
      props: {
        layout: "pc",
      },
    }),
}).$mount("#app");
